import { useEffect, useState } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, wide = false }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-black/80 p-4 backdrop-blur-sm" onClick={onClose}>
      <div
        className={`my-10 w-full ${wide ? "max-w-3xl" : "max-w-xl"} rounded-lg border border-yaza-border bg-yaza-surface p-6`}
        onClick={(e) => e.stopPropagation()}
        data-testid="admin-modal"
      >
        <div className="mb-6 flex items-center justify-between">
          <h3 className="font-display text-2xl tracking-wide">{title}</h3>
          <button onClick={onClose} data-testid="modal-close" className="text-neutral-400 hover:text-white"><X size={22} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export const field = "w-full rounded border border-yaza-border bg-black px-3 py-2 text-sm outline-none focus:border-yaza-accent";
export const lbl = "mb-1 block text-xs uppercase tracking-widest text-neutral-500";
